import { Product, Purchase, track } from '@dfds-frontend/tracking'

import { TrackingData } from '../_actions/getTrackingData'
import { FindOfferCode } from './products'

export const trackPurchaseEcommerce = (data: TrackingData, products: Product[]): void => {
  const revenue: number = products.map((p: Product) => Number(p.price) * Number(p.quantity)).reduce((a, b) => a + b, 0)
  track<Purchase>({
    discountScheme: false,
    ecommerce: {
      purchase: {
        actionField: {
          affiliation: 'PAXOB',
          coupon: FindOfferCode(data),
          currencyCode: data.currency,
          id: data.reservationCode!,
          payment_method: data.paymentMethod!,
          revenue: revenue.toString(),
          shipping: '0.00',
          tax: '0.00',
        },
        products: products,
      },
    },
    event: 'purchase',
  })
}
